// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HhsPatient {
    static getAttributeTypeMap() {
        return HhsPatient.attributeTypeMap;
    }
}
HhsPatient.discriminator = undefined;
HhsPatient.attributeTypeMap = [
    {
        "name": "ssnLast4",
        "baseName": "ssnLast4",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "assignedGender",
        "baseName": "assignedGender",
        "type": "HhsAssignedGender"
    },
    {
        "name": "genderIdentity",
        "baseName": "genderIdentity",
        "type": "HhsGenderIdentity"
    },
    {
        "name": "race",
        "baseName": "race",
        "type": "HhsRace"
    },
    {
        "name": "ethnicity",
        "baseName": "ethnicity",
        "type": "Ethnicity"
    },
    {
        "name": "emailAddress",
        "baseName": "emailAddress",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "phoneNumberType",
        "baseName": "phoneNumberType",
        "type": "HhsPhoneType"
    },
    {
        "name": "canLeaveVoicemail",
        "baseName": "canLeaveVoicemail",
        "type": "boolean"
    },
    {
        "name": "bestTimeToContact",
        "baseName": "bestTimeToContact",
        "type": "HhsBestTimeToCall"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "HhsAddress"
    },
    {
        "name": "thirdPartyId",
        "baseName": "thirdPartyId",
        "type": "string"
    }
];
//# sourceMappingURL=hhsPatient.js.map